import styled from "styled-components";
import { theme } from "../../../../styles/legacy-theme";

type Props = {
  hasError?: boolean;
};

const TextArea = styled.textarea<Props>`
  width: 100%;
  box-sizing: border-box;
  height: 8rem;
  font-family: "Inter", sans-serif;
  font-size: 1rem;
  color: ${theme.colors.Font02};
  padding: 1rem;
  resize: none;
  border-radius: 12px;
  outline: transparent;
  border: ${({ hasError }) =>
    hasError
      ? `1px ${theme.colors.ErrorRed} solid`
      : `1px ${theme.colors.Grey02} solid`};

  &:focus {
    border: 1px ${theme.colors.Primary01} solid;
  }
`;

export default TextArea;
